import { Pagination, Table } from 'antd';
import React, { FC } from 'react';
import { IPreparedFaqPublicated, TFaqColumns } from 'shared/types/faq.types';
import SearchComponent from 'shared/components/search/news-faq';
import StringFormItem from 'shared/components/search/news-faq/stringFormItem/StringFormItem';
import { SearchKeysFaq } from 'shared/enums/FAQ';
import CategoriesFormItem from 'shared/components/search/news-faq/categoriesFormItem/CategoriesFormItem';
import NumberFormItem from 'shared/components/search/news-faq/numberFormItem/NumberFormItem';
import style from './index.module.scss';

type TProps = {
  dataSource: IPreparedFaqPublicated[];
  columns: TFaqColumns;
  currentPage: number;
  currentSize: number;
  setCurrentPage: React.Dispatch<React.SetStateAction<number>>;
  setCurrentSize: React.Dispatch<React.SetStateAction<number>>;
  total: number | undefined;
  onSearch: (data: string | null, key: SearchKeysFaq) => void;
  onclickToRow?: (id: number) => void;
};

const FaqTable: FC<TProps> = ({
  columns,
  currentPage,
  currentSize,
  dataSource,
  setCurrentPage,
  setCurrentSize,
  total,
  onclickToRow,
  onSearch,
}) => {
  const handlePagination = (value: number, pageSize: number) => {
    setCurrentSize(pageSize);
    setCurrentPage(value);
  };
  return (
    <>
      <SearchComponent
        selectOptions={{
          [SearchKeysFaq.SEARCH_TITLE]: {
            name: SearchKeysFaq.SEARCH_TITLE,
            alias: 'Заголовок',
            node: StringFormItem({
              name: SearchKeysFaq.SEARCH_TITLE,
              placeholder: 'Введите заголовок',
              onSearch: data => {
                onSearch(data, SearchKeysFaq.SEARCH_TITLE);
              },
            }),
          },
          [SearchKeysFaq.SEARCH_NAME]: {
            name: SearchKeysFaq.SEARCH_NAME,
            alias: 'ФИО',
            node: StringFormItem({
              name: SearchKeysFaq.SEARCH_NAME,
              placeholder: 'Введите ФИО',
              onSearch: data => {
                onSearch(data, SearchKeysFaq.SEARCH_NAME);
              },
            }),
          },
          [SearchKeysFaq.SEARCH_CATEGORY]: {
            name: SearchKeysFaq.SEARCH_CATEGORY,
            alias: 'Категория',
            node: CategoriesFormItem({
              name: SearchKeysFaq.SEARCH_CATEGORY,
              placeholder: 'Выберите категорию',
              onSearch: data => {
                onSearch(data, SearchKeysFaq.SEARCH_CATEGORY);
              },
            }),
          },
          [SearchKeysFaq.SEARCH_ID]: {
            name: SearchKeysFaq.SEARCH_ID,
            alias: 'Номер',
            node: NumberFormItem({
              name: SearchKeysFaq.SEARCH_ID,
              placeholder: 'Введите номер вопроса',
              onSearch: data => {
                onSearch(data, SearchKeysFaq.SEARCH_ID);
              },
            }),
          },
        }}
      />
      <Table
        scroll={{ x: true }}
        dataSource={dataSource}
        columns={columns}
        rowClassName="row"
        pagination={false}
        bordered
        onRow={(record, rowIndex) => {
          return {
            onClick: () => {
              if (onclickToRow) {
                onclickToRow(+record.id);
              }
            },
          };
        }}
      />
      <div className={style.paginationWrap}>
        <Pagination
          defaultCurrent={1}
          showSizeChanger
          current={currentPage}
          total={total}
          pageSize={currentSize}
          onChange={(page, pageSize) => handlePagination(page, pageSize)}
        />
      </div>
    </>
  );
};

export default FaqTable;
